import Lodash from 'lodash';
export function buildUrl(url, params) {
  if (!params) {
    return url;
  }
  const parts = Lodash(params).map((value, key) => {
    if (Lodash.isNil(value)) {
      return '';
    }
    if (Lodash.isDate(value) && !isNaN(value.valueOf())) {
      value = value.toISOString();
    } else if (Lodash.isObject(value)) {
      value = JSON.stringify(value);
    }
    return `${encode(key)}=${encode(value)}`;
  }).compact().value();
  if (parts.length !== 0) {
    url += (Lodash.includes(url, '?') ? '&' : '?') + parts.join('&');
  }
  return url;
}
export function encode(value) {
  return encodeURIComponent(value).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/gi, '$').replace(/%2C/gi, ',').replace(/%20/gi, '+');
}
//# sourceMappingURL=build-url.js.map